import React from "react"

import BenefitMaster from "./BenefitMaster"
import { Color } from "../../../../../constants/V2/color"

type Props = {
  cardWidth?: "6-col" | "8-col" | "12-col"
  primaryBackgroundColor: Color
  secondaryBackgroundColor?: Color
  superscriptText?: string
  titleText: string
  titleSize?: "h3" | "lead-lg"
  descriptionText: string
  imageUrl: string
  imageAlt: string
  iconUrl?: string
  iconAlt?: string
  buttonText?: string
  buttonLink?: string
  buttonBorderColor?: Color
  mobileGridOrder?: number
}

const Copy = (props: Props) => {
  return <BenefitMaster {...props} />
}

export default Copy
